import { render, staticRenderFns } from "./subordinatePolicyDetails.vue?vue&type=template&id=e637d646&scoped=true"
import script from "./subordinatePolicyDetails.vue?vue&type=script&lang=js"
export * from "./subordinatePolicyDetails.vue?vue&type=script&lang=js"
import style0 from "./subordinatePolicyDetails.vue?vue&type=style&index=0&id=e637d646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e637d646",
  null
  
)

export default component.exports